export default __webpack_public_path__ + "static/char-s-42-en-ef46c5c72c93121908a4541275d5a88c.png";